import type { FaireProductEntity } from "../../entity_types/product";

export const atc_baggu_9: FaireProductEntity = {
  token: "atc_baggu_9",
  type: "product",
  name: "Puffy Glasses Case - Bunny",
  brandName: "Baggu",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4f36e03e95eb231d963d0b281d3df53c36f83fab22278a214a61b8999432600e.jpeg",
  priceDollars: 14,
  msrpDollars: 28,
  description: "Reusable bag made from recycled materials by Baggu.",
  tags: ["bags", "accessories", "sustainable"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
